import React from "react";
import LandingHome from "../section/LandingHome";
import AboutSection from "../section/AboutSection";
import CollectionsSection from "../section/CollectionsSection";
import VisionSection from "../section/VisionSection";

export default function HomePage() {

    return (
        <>
            <LandingHome />
            <AboutSection />
            <CollectionsSection />
            <VisionSection/>
        </>
    );
}